import { apiGetAddresses, apiSaveAddress } from "../../api/Argentia/endpoints/addresses/addresses.api";
import { AddressTypeEnum } from "../../api/Argentia/enums/addressTypeEnum";
import { createErrorServiceResponse, createSuccessServiceResponse } from "../../helpers/serviceResponseHelper";
import { ServiceResponse } from "../../model/serviceResponse";
import { addressMapper } from "./addresses.mapper";
import { AddressDataFormModel } from "./addresses.model";

export const saveAddress = async (
    addressDataForm: AddressDataFormModel,
    addressType: AddressTypeEnum
): Promise<ServiceResponse<any>> => {
    return await apiSaveAddress(addressMapper(addressDataForm, addressType))
        .then(response => {
            return createSuccessServiceResponse(response);
        })
        .catch(error => {
            return createErrorServiceResponse(error);
        });
};

export const fetchAddresses = async (
    contractID: number,
    addressType: AddressTypeEnum
): Promise<ServiceResponse<any>> => {
    return await apiGetAddresses(contractID, addressType)
        .then(response => {
            return createSuccessServiceResponse(response);
        })
        .catch(error => {
            return createErrorServiceResponse(error);
        });
};